import { Suspense } from "react";
import { AuthProvider } from "common/providers/AuthProvider";
import { LoadingProvider } from "common/providers/LoadingProvider";
import { AlertsProvider } from 'common/providers/alerts';
import { ContentProvider } from 'common/providers/ContentProvider';
import { SocketProvider } from 'common/providers/SocketProvider';

type Props = {
  children: JSX.Element;
};

function AppProvider({ children }: Props) {
  return (
    <Suspense>
      <LoadingProvider>
        <SocketProvider>
          <AlertsProvider>
            <AuthProvider>
              <ContentProvider>{children}</ContentProvider>
            </AuthProvider>
          </AlertsProvider>
        </SocketProvider>
      </LoadingProvider>
    </Suspense>
  );
}

export default AppProvider;
